import { Alert } from "../../components/alert/alert";
export function setInvalid(el) {
    if (el.type == 'file') {
        $(el).closest('.control-file').addClass('control--invalid');
    }
    else if (el.type == 'checkbox') {
        // let invalidLabel = '<span class="checkbox-invalid"> Privalote pažymėti </span>'
        // if (!$(el).closest('.col').find('span.checkbox-invalid').length) {
        // 	$(el).closest('.col').append(invalidLabel);
        // }
        $(el).closest('.control-wrap').find('.control-checkbox-box').addClass('border-danger');
    }
    else if (el.getAttribute('is') == 'control-radio-group') {
        el.classList.add('border-danger');
    }
    else if (el.classList.contains('control-select-radio')) {
        var control = el.querySelector('.control.control--pseudo');
        control && control.classList.add('border-danger');
    }
    else {
        el.classList.add('border-danger');
    }
}
export function setValid(el) {
    if (el.type == 'file' && el.checkValidity()) {
        $(el).closest('.control-file').removeClass('control--invalid');
    }
    else if (el.classList.contains('control-select-radio') && el.checkValidity()) {
        var control = el.querySelector('.control.control--pseudo');
        control && control.classList.remove('border-danger');
    }
    else if (el.getAttribute('is') == 'control-radio-group') {
        el.classList.remove('border-danger');
    }
    else if (el.type == 'checkbox' && el.checkValidity()) {
        $(el).closest('.control-wrap').find('.control-checkbox-box').removeClass('border-danger'); // $(el).closest('.col').find('.checkbox-invalid').remove();
    }
    else if (el.classList.contains('border-danger')) {
        el.classList.remove('border-danger');
    }
}
export function spfMiddleWareStart(_ref, wizard) {
    var currentPane = _ref.currentPane, openingPane = _ref.openingPane, initiator = _ref.initiator;
    var select = document.querySelector('fieldset[name="PersonType"]');
    var firstWare = validateStep({
        currentPane: currentPane,
        openingPane: openingPane,
        initiator: initiator
    }, wizard);
    if (firstWare != false) {
        var select_value = select.value;
        window.location = '?who=' + select.value;
    }
    return false;
}
export function spfMiddleWare(_ref2, wizard) {
    var currentPane = _ref2.currentPane, openingPane = _ref2.openingPane, initiator = _ref2.initiator;
    var params = new URLSearchParams(window.location.search);
    var who = params.get('who');
    var select = document.querySelector('fieldset[name="PersonType"]');
    var firstWare = validateStep({
        currentPane: currentPane,
        openingPane: openingPane,
        initiator: initiator
    }, wizard);
    if (firstWare != false) {
        var select_value = select.value;
        if (who != select_value) {
            if (confirm('Ar tikrai norite pakeisti pasirinkimą? (Dings jūsų suvesta informacija)')) {
                window.location = '?who=' + select.value;
                return false;
            }
            else {
                select.value = who;
                return false;
            }
        }
    }
    return firstWare;
}
export function validateFormFields(form) {
    var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isValid = true, fileSize = 0;
    var fields = $(form).find('[name]:not([disabled]):not([data-select-radio]):not([type=hidden]):not([role=presentation])');
    if (fields.length === 0) {
        return false;
    }
    if (fields.length == 1) {
        var extraDoc = fields[0];
        if (extraDoc.name == 'extraDoc[]' && !extraDoc.value) {
            return false;
        }
        ;
    }
    fields.each(function (i, el) {
        if (el.type !== 'select-one' && el.type !== 'file' && el.name && !!el.value) {
            el.value = el.value.replace(/\s+/g, ' ').trim();
            if (el.value == ' ') {
                el.value = '';
            }
        }
        if (!el.checkValidity()) {
            isValid = false;
            if (!silent) {
                setInvalid(el);
                $(el).change(function () {
                    setValid(el);
                });
            }
        }
        else {
            setValid(el);
        }
        if (el.type == 'file' && el.files.length) {
            fileSize += el.files[0].size;
        }
    });
    if (fileSize / 1024 / 1024 > 30 && !silent) {
        new Alert({
            title: 'Laiško turinys viršija leistiną 30 MB dydį',
            content: 'Patikrinkite pridėtų priedų dydį ir jei reikia suspauskite.',
            type: 'warning'
        });
        return false;
    }
    return isValid;
}
/**
 * Wizardo tabu atidarymo middleware
 * @param {HTMLDivElement} currentPane atidarytas tabas
 * @param {HTMLDivElement} openingPane atidaromas tabas
 * @param {HTMLDivElement | HTMLButtonElement} initiator kas buvo paspausta
 * @returns true - tesia atidaryma, false - stabdo atidaryma
 */
export function validateStep(_ref3, wizard) {
    var currentPane = _ref3.currentPane, openingPane = _ref3.openingPane, initiator = _ref3.initiator;
    var isReallyValid = function () {
        wizard.panes && wizard.panes.map(function (pane) {
            var paneValid = validateFormFields(pane, true);
            var step = wizard.wrap.querySelector(".wizard-step[data-step-id=\"".concat(pane.id, "\"]"));
            step.classList.toggle('wizard-step--valid', paneValid);
            step.classList.toggle('wizard-step--default', !paneValid);
        });
        if (initiator.classList.contains('btn-prev'))
            return true;
        if (initiator.classList.contains('wizard-step--complete'))
            return true;
        if (initiator.classList.contains('wizard-step--active'))
            return false;
        if (initiator.classList.contains('wizard-step--default')) {
            // leiziam atidaryt paskutini neliesta
            // jei pries ji esantis complete yra validus
            var prevStep = initiator.previousElementSibling;
            if (prevStep && prevStep.classList.contains('wizard-step--valid')) {
                var prevStepPane = document.getElementById(prevStep.dataset.stepId);
                var prevStepValid = validateFormFields(prevStepPane);
                if (prevStepValid) {
                    return true;
                }
            }
            else {
                scrollToInvalid(currentPane);
                return false;
            }
        }
        var isValid = validateFormFields(currentPane);
        if (!isValid) {
            scrollToInvalid(currentPane);
        }
        return isValid;
    }();
    return isReallyValid;
}
function scrollToInvalid(fieldset) {
    var firstInvalid = fieldset.querySelector('.control-wrap .border-danger');
    if (!firstInvalid) {
        firstInvalid = fieldset.querySelector('.control--invalid');
    }
    if (firstInvalid) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(firstInvalid).offset().top - 200
        }, 300);
    }
}
